module.exports = __webpack_public_path__ + "img/photo-lifestyle-lighting.5ce3a87c.png";